"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserTier = exports.UserTierProvider = void 0;
var constate_1 = __importDefault(require("constate"));
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var _LaunchpadProvider_1 = require("../../LaunchpadProvider");
var _abi_1 = require("../../abi");
var _launchpadConstants_1 = require("../../launchpadConstants");
var hooks_1 = require("../../shared/hooks");
var utils_1 = require("../../shared/utils");
var multicall_1 = require("../../shared/utils/multicall");
var useLevelManager_1 = require("../../tiers/hooks/useLevelManager");
function useUserTierRaw() {
    var _a = (0, _LaunchpadProvider_1.useLaunchpadProvider)(), levels = _a.levels, mainToken = _a.mainToken;
    var staticWeb3 = (0, hooks_1.useWeb3Provider)().staticWeb3;
    var account = (0, hooks_1.useUser)().account;
    var _b = (0, hooks_1.useRegistryContractAddress)('levelManager'), address = _b.addresses[0], version = _b.version;
    var _c = (0, react_1.useState)(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, react_1.useState)({
        tierId: 'none',
        nextTierId: 'none',
        tier: levels === null || levels === void 0 ? void 0 : levels.none,
        totalAmount: _launchpadConstants_1.ZERO_BN,
        isLocked: false,
        unlocksAt: 0,
    }), tierState = _d[0], setTierState = _d[1];
    var refresh = (0, react_1.useCallback)(function () {
        if (!account)
            return Promise.reject();
        (0, utils_1.debug)('getUserTierPools', account, address);
        return (0, multicall_1.multicallTransformed)({
            web3: staticWeb3,
            abi: _abi_1.CONTRACTS.levelManager[version].abi,
            address: address,
            methods: {
                getUserTierStatus: function (v) { return v; },
            },
            args: {
                getUserTierStatus: [account],
            },
            returnCachedOnError: true,
        })
            .then(function (_a) {
            var state = _a[0];
            var rawTier = state[0], totalAmount = state[1], isLocked = state[2], unlocksAt = state[3];
            var tier = __assign(__assign({}, levels[rawTier.id]), { 
                // Multiplier, aag, vip can change based on where user stakes, for example. Get them directly from the contract returned tier
                multiplier: rawTier.multiplier / useLevelManager_1.MULTIPLIER_DECIMALS, vip: rawTier.vip, aag: rawTier.aag });
            var tierState = {
                tierId: tier.id,
                nextTierId: getNextTierId(levels, tier.id),
                tier: tier,
                totalAmount: (0, utils_1.normalizeDecimals)((0, web3_utils_1.toBN)(totalAmount), mainToken.decimals),
                unlocksAt: parseInt(unlocksAt, 10),
                isLocked: isLocked,
            };
            setTierState(tierState);
            (0, utils_1.debug)('useUserTier.tierState', tierState);
        })
            .catch(function (e) {
            console.error('Failed to refresh user tier', e);
        });
    }, [staticWeb3, account, address]);
    (0, react_1.useEffect)(function () {
        setIsLoading(true);
        refresh()
            .then(function () { return setIsLoading(false); })
            .catch(function () { });
    }, [refresh, account]);
    return {
        tierState: tierState,
        isLoading: isLoading,
        refresh: refresh,
    };
}
var _a = (0, constate_1.default)(useUserTierRaw), UserTierProvider = _a[0], useUserTier = _a[1];
exports.UserTierProvider = UserTierProvider;
exports.useUserTier = useUserTier;
function getNextTierId(levels, currentId) {
    var _a;
    if (!currentId) {
        return currentId;
    }
    var curTierV = ((_a = levels[currentId]) === null || _a === void 0 ? void 0 : _a.minAmount) || 0;
    var max = { id: currentId, diff: Infinity };
    Object.values(levels).forEach(function (tier) {
        var diff = tier.minAmount - curTierV;
        if (diff > 0 && diff < max.diff) {
            max = { id: tier.id, diff: diff };
        }
    });
    return max.id !== currentId ? max.id : currentId;
}
